import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PostDetails from "../../components/Blog-Sections/Posts/details";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { getPublishedBlogPostBySlugORID } from "../../controllers/blogController";
import HeadSection from "../../components/meta";
import StructuredData from "../../components/meta/structure_data";
import { MODEL } from "../../model";
import BannerAd from "../../components/Ads/bannerAd";
import { formatDate } from "../../utils/dateFormate";

const BlogDetails = () => {
  const { slug } = useParams();

  const navigate = useNavigate();
  const postSlug = slug ? slug : null;

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPostData = async () => {
      if (!postSlug) {
        navigate("/", { replace: true });
        return;
      }

      const postData = await getPublishedBlogPostBySlugORID(postSlug);

      if (postData) {
        setPost(postData);
      } else {
        navigate("/404", { replace: true });
      }
      setLoading(false);
    };

    getPostData();
  }, [navigate, postSlug]);

  if (loading) return <div>Loading...</div>;

  if (!post) {
    return <div>Post not found!</div>;
  }

  // 1. Safely parse stringified JSON fields
  const imageObj =
    typeof post.image === "string" ? JSON.parse(post.image) : post.image;
  const authorObj =
    typeof post.author === "string" ? JSON.parse(post.author) : post.author;

  // 2. Safely calculate the image source
  const imgSrc = imageObj?.src
    ? imageObj.src.startsWith("http")
      ? imageObj.src
      : `/${imageObj.src}`
    : "/assets/images/default-placeholder.jpg";

  return (
    <Fragment>
      {post && (
        <>
          <HeadSection
            title={`${post.title} | BLOG`}
            addPostFixTitle={true}
            showCanonical={true}
            keywords={post.tags.trim()}
            largeTwitterCard={true}
            imageCard={imgSrc}
            content={`Read the blog post titled “${post.title}” on the Seed To Tree Academy website.`}
            link={`${MODEL.app.base_url}/blog/${post.slug}`}
          />
          {/* ✅ Ensure Structured Data is Outside HeadSection */}
          <StructuredData
            type="article"
            title={post.title}
            description={post.description}
            url={`${MODEL.app.base_url}/blog/${post.slug}`}
            image={imgSrc}
            authorName={post.author.name}
            publishedAt={formatDate(post.datePublished)}
            modifiedAt={formatDate(post.dateModified)}
          />
          <Header isActive="blog" />
          <PostDetails post={post} />
          <BannerAd />
        </>
      )}
      <Footer />
    </Fragment>
  );
};

export default BlogDetails;
